export const comments_5588988 = {"data":{"data":[],"links":{}}}